<template>
  <img v-if="logo" :src="logo" />
</template>

<script>
import useCompany from '@/compositions/useCompany';
import { computed } from '@vue/composition-api';

export default {
  name: 'CompanyLogo',
  setup() {
    const { company } = useCompany();
    return {
      logo: computed(() => company.value.logo?.file.url),
    };
  },
};
</script>

<style scoped>

</style>
